import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules"; // ✅ Correct import
import "swiper/css";
import "swiper/css/autoplay";

import slide1 from "../assets/slidee3.jpeg";
import slide2 from "../assets/slidee2.jpeg";
import slide3 from "../assets/slidee1.jpeg";
// import slide4 from "../assets/slide4.jpg";
// import slide5 from "../assets/slide5.jpg";

const Carousel = () => {
  const slides = [slide1, slide2, slide3];

  return (
    <div className="relative w-full h-[80vh]">
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        className="h-full"
      >
        {slides.map((src, i) => (
          <SwiperSlide key={i}>
            <img
              src={src}
              alt={`Slide ${i + 1}`}
              className="w-full h-full object-cover"
            />
          </SwiperSlide>
        ))}
      </Swiper>

 {/* Tagline + Donate Button */}
<div className="absolute bottom-8 left-8 z-10 bg-black/70 text-lime-400 px-6 py-4 rounded-lg shadow-lg max-w-sm">
  <h2 className="text-2xl font-bold">
    Nature & People United for a Sustainable Life 🌿
  </h2>
  <p className="text-sm mt-2 text-white">
    Together we can make it possible.
  </p>

  {/* Donate Button */}
  <button
    className="mt-4 px-6 py-2 bg-lime-500 text-black font-semibold rounded-full shadow-lg hover:bg-lime-400 hover:scale-105 transition transform duration-300"
  >
    Donate Now
  </button>
</div>


    </div>
  );
};

export default Carousel;
